/**
 * 주어진 날짜를 로컬 형식으로 포맷하여 반환합니다.
 *
 * @param {Date|string} dateValue - 포맷할 날짜 객체 혹은 string 형식의 날짜
 * @param {Object} [options={}] - 포맷 옵션 객체
 * @param {boolean} [options.year=true] - 연도를 포함할지 여부
 * @param {boolean} [options.month=true] - 월을 포함할지 여부
 * @param {boolean} [options.day=true] - 일을 포함할지 여부
 * @param {string} [options.separator='.'] - 날짜 구성 요소를 구분할 구분자
 * @returns {string} 포맷된 날짜 문자열
 */
export const getLocalDate = (dateValue, options = {}) => {
  const { year = true, month = true, day = true, separator = '.' } = options
  try {
    const date = new Date(dateValue)

    return new Intl.DateTimeFormat('ko-KR', {
      year: year ? 'numeric' : undefined,
      month: month ? '2-digit' : undefined,
      day: day ? '2-digit' : undefined,
    })
      .format(date)
      .replaceAll('.', '')
      .replaceAll(' ', separator)
  } catch (e) {
    return ''
  }
}

/**
 * 주어진 날짜를 로컬 시간 형식으로 포맷하여 반환합니다.
 *
 * @param {Date|string} dateValue - 포맷할 날짜 객체 혹은 string 형식의 날짜
 * @param {Object} [options={}] - 포맷 옵션 객체
 * @param {boolean} [options.hour12=false] - 12시간 형식을 사용할지 여부
 * @param {boolean} [options.hour=true] - 시간을 포함할지 여부
 * @param {boolean} [options.minute=true] - 분을 포함할지 여부
 * @param {boolean} [options.second=true] - 초를 포함할지 여부
 * @param {string} [options.separator=':'] - 시간 구성 요소를 구분할 구분자
 * @returns {string} 포맷된 시간 문자열
 */
export const getLocalTime = (dateValue, options = {}) => {
  const {
    hour12 = false,
    hour = true,
    minute = true,
    second = true,
    separator = ':',
  } = options
  try {
    const date = new Date(dateValue)

    return new Intl.DateTimeFormat('ko-KR', {
      hour12,
      hour: hour ? '2-digit' : undefined,
      minute: minute ? '2-digit' : undefined,
      second: second ? '2-digit' : undefined,
    })
      .format(date)
      .replaceAll(':', separator)
  } catch (e) {
    return ''
  }
}
